import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Modal } from "@/components/General/Modal/modal";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { load as loadPhoneNumberPrefixes } from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.module";
import { load as loadVatPrefixes } from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.module";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import {
    EditProfileForm,
    EditProfileFormValues
} from "./editProfileForm.component";

const EditProfileModal = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const { t } = useGranite();
    const customer = useSelector(CustomerSelectors.getCustomer);
    const isLoadingCustomer = useSelector(CustomerSelectors.isLoading);
    const dispatch = useThunkDispatch();

    useEffect(() => {
        dispatch(loadPhoneNumberPrefixes());
        dispatch(loadVatPrefixes());
    }, [dispatch]);

    const submitForm = async (formValues: EditProfileFormValues) => {
        if (!customer) {
            return;
        }

        clearMessageById("customerDetails-feedback-success");
        clearMessageById("customerDetails-feedback-failure");

        const action = await dispatch(
            CustomerModule.updateFromData({
                ...customer,
                ...formValues,
                vatNr: formValues.vatInfo?.vatNr,
                vatNrPrefix: formValues.vatInfo?.vatNrPrefix,
                companyName: formValues.vatInfo?.companyName,
                dateOfBirth: formValues.dateOfBirth?.toISOString()
            })
        );
        if (action.type === CustomerModule.APIStatus.SUCCESS) {
            broadcastMessage({
                id: "customerDetails-feedback-success",
                text: t("general.customerDetail.modal.feedback.success"),
                status: "success",
                dismissible: true,
                activeScroll: true
            });
            setModalOpen(false);
        } else {
            broadcastMessage({
                id: "customerDetails-feedback-failure",
                text: t("general.customerDetail.modal.feedback.failure"),
                status: "danger",
                dismissible: true
            });
        }
    };

    return (
        <>
            {customer && (
                <div>
                    <Button
                        test="profileDetails-button-changeDetails"
                        className={cn("tw:pl-0")}
                        color="link"
                        type="button"
                        onClick={() => setModalOpen(true)}
                    >
                        <i className={cn("las la-pencil-alt", "tw:mr-2")} />
                        {t("account.profileDetails.link.changeDetails")}
                    </Button>
                    <Modal
                        modalType={ModalType.ProfileEditDetails}
                        title={t("general.customerDetail.modal.title")}
                        subtitle={t("general.customerDetail.modal.subtitle")}
                        formId={"customerDetailsModal"}
                        open={isModalOpen}
                        setOpen={() => setModalOpen(false)}
                        confirmButtonText={t(
                            "general.customerDetail.modal.button.label"
                        )}
                        isLoading={isLoadingCustomer}
                    >
                        <EditProfileForm
                            customer={customer}
                            onSubmit={submitForm}
                        />
                    </Modal>
                </div>
            )}
        </>
    );
};

export default EditProfileModal;
